/**
 * Indica se o módulo Indicação está disponível para o profissional no app.
 */
export function indicacaoModuloDisponivel(dados) {
	if (dados?.config?.indicar === false) return false
	return dados?.modulos?.indicacao?.ativo === 'S'
}
